import React from "react";
import { Reveal, Eyebrow, StaggerGroup, StaggerItem } from "./Reveal";
import { COURSE } from "../../data/course";

export default function Overview() {
  return (
    <section id="overview" data-testid="overview-section" className="relative py-24 md:py-32">
      <div className="pointer-events-none absolute right-0 top-1/2 h-[400px] w-[400px] -translate-y-1/2 glow-blue opacity-60" />
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid gap-14 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20">
          <div>
            <Reveal>
              <Eyebrow>The Program</Eyebrow>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-display text-4xl font-semibold leading-[1.05] tracking-tight text-[#293891] sm:text-5xl lg:text-[3.4rem]">
                Built for the
                <br />
                <span className="text-stroke-red">AI era</span> of data.
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-8 max-w-md text-base leading-relaxed text-[#566076] md:text-lg">
                {COURSE.whoShouldEnroll}
              </p>
            </Reveal>
          </div>

          <StaggerGroup className="grid gap-px overflow-hidden rounded-3xl border border-[#293891]/10 bg-[#293891]/[0.03] sm:grid-cols-2">
            {COURSE.overviewChapters.map((c) => (
              <StaggerItem
                key={c.no}
                className="group relative bg-[#FFFFFF] p-8 transition-colors duration-500 hover:bg-[#F3F6FC]"
              >
                <span className="font-display text-5xl font-semibold text-[#293891]/10 transition-colors duration-500 group-hover:text-[#e63329]/70">
                  {c.no}
                </span>
                <h3 className="mt-4 font-display text-xl font-medium text-[#293891]">{c.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[#566076]">{c.body}</p>
              </StaggerItem>
            ))}
          </StaggerGroup>
        </div>
      </div>
    </section>
  );
}
